import React, { useState } from "react";
import {
  Box,
  Heading,
  Button,
  Text,
  Link,
  useDisclosure,
  Select,
  Tooltip,
} from "@chakra-ui/react";
import { DynoIcon } from "../DynoIcon";
import { EditIcon } from "../Icons/EditIcon";
import { DeleteIcon } from "../Icons/DeleteIcon";
import { InfoIcon } from "../Icons/InfoIcon";
import { CopyIcon } from "../Icons/CopyIcon";
import { ShareIcon } from "../Icons/ShareIcon";
import { editDynoUrl, viewDynoUrl } from "../../utils/helper";
import { ModalBox } from "../ModalBox";
import { LockIcon, UnlockIcon, AddIcon, MinusIcon, CloseIcon } from "@chakra-ui/icons";
import { COURSE, PUBLIC, PRIVATE } from "../../constants";

export const DynoItem = ({
  dyno,
  isContentPage,
  copyDynoCallback,
  deleteDynoCallback,
  shareCallback,
  modalTitle,
  updatDynoStatusCallback,
  isAdmin,
  publishStatus,
  isOrgDynoes = false,
  shareStatusCallback,
  isLocked,
  onChangeLock,
  dynosUnderListId,
  listId,
  productType,
  updatDynoAccessType,
  openContent
}) => {
  const {
    isOpen: isInfoModalOpen,
    onOpen: onInfoModelOpen,
    onClose: onInfoModelClose,
  } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModelOpen,
    onClose: onDeleteModelClose,
  } = useDisclosure();
  const dynoPublishingStatus = [
    { id: "ReWorking", status: "In Progress" },
    { id: "ReadyForQA", status: "Ready for QA" },
    { id: "VerifiedByQA", status: "Verified by QA" },
  ];
  const [publishingStatus, setPublishingStatus] = useState(
    dyno.dynoPublishingStatus
  );
  const dynoPublishStatus = {
    NotStarted: "Not Started",
    InProgress: "In Progress",
    ReWorking: "ReWork In Progress",
    ReadyForQA: "Ready for QA",
    VerifiedByQA: "Verified by QA",
    AddedToProductLine: "Added to product line",
  };

  const isPublished =
    dyno.dynoPublishingStatus === "NotStarted" ||
      dyno.dynoPublishingStatus === "InProgress" ||
      dyno.dynoPublishingStatus === "ReWorking" ||
      dyno.dynoPublishingStatus === "ReadyForQA" ||
      !dyno.dynoPublishingStatus
      ? false
      : true;
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      borderTop="1px solid rgba(34, 63, 153, 0.1)"
      padding="10px"
    >
      <Box display="flex" alignItems="center" width="35%" ml={3}>
        <DynoIcon dynoType={dyno.dynoType.name} />
        <Link
          href={viewDynoUrl(dyno.id)}
          rel="noreferrer"
          target="_self"
          title="View EdDoc"
        >
          <Heading
            as="h4"
            size="sm"
            ml="10px"
            color="#424770"
            fontWeight={400}
          >
            {dyno.dynoTitle}
          </Heading>
        </Link>
      </Box>
      <Box width="13%">
        {isContentPage && isAdmin && !publishStatus ? (
          <Select
            variant="outline"
            onChange={(event) => {
              setPublishingStatus(event.target.value);
              updatDynoStatusCallback(event.target.value, dyno.id);
            }}
            value={publishingStatus}
          >
            {dynoPublishingStatus.map((dynoStatus) => (
              <option
                key={dynoStatus.id}
                value={dynoStatus.id}
                className={dynoStatus.id}
              >
                {dynoStatus.status}
              </option>
            ))}
          </Select>
        ) : (
          <Text className={`font-opensans ${dyno.dynoPublishingStatus}`} fontSize="md">
            {dynoPublishStatus[dyno.dynoPublishingStatus]}
          </Text>
        )}
      </Box>
      {
        !isContentPage ?
        <Box width="20%" marginLeft="5px">
          <Link onClick={() => openContent(dyno?.productReferences.length > 0 && dyno?.productReferences[0] )} color="blue.500" textDecor="underline">{dyno?.productReferences[0]?.productName}</Link>
        </Box> : null
      }
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        width={"30%"}
      >
        {isContentPage ? 
          <>
            {!isPublished && isAdmin && (
              <Tooltip label="Edit EdDoc" hasArrow bg='gray.700'>
                <Link
                  href={editDynoUrl(dyno.id)}
                  rel="noreferrer"
                  target="_self"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="30px"
                  height="30px"
                  mr="4"
                  _hover={{
                    background: "#e2e8f0",
                    borderRadius: "6px",
                  }}
                  _focus={{
                    background: "#e2e8f0",
                    borderRadius: "6px",
                  }}
                  _active={{
                    background: "#e2e8f0",
                    borderRadius: "6px",
                  }}
                >
                  <EditIcon />
                </Link>
              </Tooltip>
            )}
            <Tooltip label="Information about EdDoc" hasArrow bg='gray.700'>
              <Button
                bg="transparent"
                size="xs"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="30px"
                height="30px"
                mr="4"
                onClick={onInfoModelOpen}
              >
                <InfoIcon />
              </Button>
            </Tooltip>
          </> :
                  <>
                  {!isPublished && (
                    <Tooltip label="Edit EdDoc" hasArrow bg='gray.700'>
                      <Link
                        href={editDynoUrl(dyno.id)}
                        rel="noreferrer"
                        target="_self"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="30px"
                        height="30px"
                        mr="4"
                        _hover={{
                          background: "#e2e8f0",
                          borderRadius: "6px",
                        }}
                        _focus={{
                          background: "#e2e8f0",
                          borderRadius: "6px",
                        }}
                        _active={{
                          background: "#e2e8f0",
                          borderRadius: "6px",
                        }}
                      >
                        <EditIcon />
                      </Link>
                    </Tooltip>
                  )}
                  <Tooltip label="Copy EdDoc" hasArrow bg='gray.700'>
                    <Button
                      bg="transparent"
                      size="xs"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="30px"
                      height="30px"
                      mr="4"
                      onClick={copyDynoCallback}
                    >
                      <CopyIcon />
                    </Button>
                  </Tooltip>
                  <Tooltip label="Information about EdDoc" hasArrow bg='gray.700'>
                    <Button
                      bg="transparent"
                      size="xs"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="30px"
                      height="30px"
                      mr={!isPublished ? "4" : 0}
                      onClick={onInfoModelOpen}
                    >
                      <InfoIcon />
                    </Button>
                  </Tooltip>
                  {!isPublished && (
                    <>
                      <Tooltip label="Add EdDoc" hasArrow bg='gray.700'>
                        <Button
                          bg="transparent"
                          size="xs"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          width="30px"
                          height="30px"
                          mr="4"
                          onClick={shareCallback}
                        >
                          <ShareIcon />
                        </Button>
                      </Tooltip>
                      <Tooltip label={isContentPage ? "Remove EdDoc" : "Delete EdDoc"} hasArrow bg='gray.700'>
                        <Button
                          bg="transparent"
                          size="xs"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          width="30px"
                          height="30px"
                          disabled={!isContentPage ? dyno?.productReferences?.length > 0 : null}
                          onClick={onDeleteModelOpen}
                        >
                          {isContentPage ? <CloseIcon color="red"/> : <DeleteIcon />}
                        </Button>
                      </Tooltip>
                    </>
                  )}
                </>
        }
        {isOrgDynoes && (
          <>
            <Tooltip label="Information about EdDoc" hasArrow bg='gray.700'>
              <Button
                bg="transparent"
                size="xs"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="30px"
                height="30px"
                mr="4"
                onClick={onInfoModelOpen}
              >
                <InfoIcon />
              </Button>
            </Tooltip>
            {!isPublished && (
              <Tooltip label="Add EdDoc" hasArrow bg='gray.700'>
                <Button
                  bg="transparent"
                  size="xs"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="30px"
                  height="30px"
                  mr="4"
                  onClick={shareCallback}
                >
                  <ShareIcon />
                </Button>
              </Tooltip>
            )}
          </>
        )}
        {isContentPage &&
          productType === COURSE &&
          (!!isLocked ||
            typeof isLocked === "undefined" ||
            typeof isLocked === "object") && (
            <Tooltip label="if a EdDoc is locked means user can only access the EdDoc if they have completed the previous one." hasArrow bg='gray.700'>
              <Button
                size="sm"
                variant="ghost"
                display="flex"
                justifyContent="center"
                alignItems="center"
                className="lock"
                mr="4"
                onClick={() => onChangeLock(false, listId, dynosUnderListId)}
              >
                <LockIcon />
              </Button>
            </Tooltip>
          )}
        {isContentPage &&
          productType === COURSE &&
          !!!isLocked &&
          typeof isLocked !== "undefined" &&
          typeof isLocked !== "object" && (
            <Tooltip label="if a EdDoc is unlocked means user can open a EdDoc in any order" hasArrow bg='gray.700'>
              <Button
                size="sm"
                variant="ghost"
                display="flex"
                justifyContent="center"
                alignItems="center"
                className="unlock"
                mr="4"
                onClick={() => onChangeLock(true, listId, dynosUnderListId)}
              >
                <UnlockIcon />
              </Button>
            </Tooltip>
          )}
        {isContentPage && (
          <>
            {dyno.accessType === PUBLIC ? (
              <Tooltip label="Remove from sample" hasArrow bg='gray.700'>
                <Button
                  variant={"outline"}
                  leftIcon={<MinusIcon size="xs"/>}
                  colorScheme="blue"
                  padding="6px"
                  fontSize="14px"
                  mr="4"
                  onClick={() => updatDynoAccessType(dyno.id, PRIVATE)}
                >
                  Sample
                </Button>
              </Tooltip>
            ) : (
              <Tooltip label="If a EdDoc is marked as a sample, it will be publicly accessible. Anyone visiting the course on the website can view this EdDoc as a preview." hasArrow bg='gray.700'>
                <Button
                  variant={"outline"}
                  leftIcon={<AddIcon fill="green" size="xs"/>}
                  colorScheme="green"
                  padding="6px"
                  fontSize="14px"
                  mr="4"
                  onClick={() => updatDynoAccessType(dyno.id, PUBLIC)}
                >
                  Sample
                </Button>
              </Tooltip>
            )}
            {!isPublished && isAdmin && (
              <Tooltip label={isContentPage ? "Remove EdDoc" : "Delete EdDoc"} hasArrow bg='gray.700'>
                <Button
                  bg="transparent"
                  size="xs"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="30px"
                  height="30px"
                  disabled={isPublished}
                  onClick={onDeleteModelOpen}
                  mr="4"
                >
                  {isContentPage ? <CloseIcon color="red"/> : <DeleteIcon />}
                </Button>
              </Tooltip>
            )}
          </>
        )}
      </Box>
      <ModalBox
        title={dyno.dynoTitle}
        description={
          <>
            <Text fontSize="md" lineHeight="1.5">
              <strong>Type:</strong> {dyno.dynoType.name}
            </Text>
            <Text fontSize="md" lineHeight="1.5">
              <strong>Category:</strong> {dyno.category.name}
            </Text>
            <Text fontSize="md" lineHeight="1.5">
              <strong>Author:</strong> {dyno.owner.firstName}{" "}
              {dyno.owner.lastName}
            </Text>
            <Text fontSize="md" lineHeight="1.5">
              <strong>Access:</strong> {dyno.accessType}
            </Text>
            <Text fontSize="md" lineHeight="1.5">
              <strong>Created:</strong> {dyno.createdAt}
            </Text>
            <Text fontSize="md" lineHeight="1.5">
              <strong>Last Updated:</strong> {dyno.updatedAt}
            </Text>
          </>
        }
        isOpen={isInfoModalOpen}
        onClose={onInfoModelClose}
        isFooter={false}
      ></ModalBox>
      <ModalBox
        title={modalTitle}
        description={
          <Text fontSize="lg">
            Are you sure you want to {isContentPage ? "remove" : "delete"}{" "}
            {dyno.dynoTitle}.
          </Text>
        }
        isOpen={isDeleteModalOpen}
        onClose={onDeleteModelClose}
        isFooter={true}
        onCancel={onDeleteModelClose}
        onConfirm={() => {
          onDeleteModelClose();
          if (
            !isContentPage &&
            (dyno.dynoPublishingStatus === "NotStarted" ||
              dyno.dynoPublishingStatus === "InProgress" ||
              !dyno.dynoPublishingStatus)
          ) {
            deleteDynoCallback();
          } else if (
            isContentPage &&
            (dyno.dynoPublishingStatus !== "VerifiedByQA" ||
              dyno.dynoPublishingStatus !== "AddedToProductLine")
          ) {
            deleteDynoCallback();
          }
        }}
        cancelButtonText="Cancel"
        confirmButtonText={isContentPage ? "Remove" : "Delete"}
        isDeleteButton={true}
      ></ModalBox>
    </Box>
  );
};
